import { styled } from '@mui/material';

export const StyledContent = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  background:'#F4F5F7',
  height:'100%',
  width: '50%',
  margin: 'auto',
  padding: theme.spacing(4),
  [theme.breakpoints.down('md')]: {
    width: '70%',
    height: 'auto',
    padding: theme.spacing(3),
  },
  [theme.breakpoints.down('sm')]: {
    width: '100%',
    height: 'auto',
    padding: theme.spacing(2),
    borderRadius: 0,
  },

}));

export const StyledCopyright = styled('div')(() => ({
  marginTop: 10,
  textAlign: 'center',
}));
